(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart"]) return;
  try {
    
  document.querySelectorAll('.pm-cart__form').forEach((form) => {
    form.querySelectorAll('.pm-cart__step').forEach((btn) => {
      btn.addEventListener('click', () => {
        const line = btn.getAttribute('data-line');
        const input = form.querySelector('[data-line-input="' + line + '"]');
        if (!input) return;
        const next = Math.max(0, (parseInt(input.value, 10) || 0) + parseInt(btn.getAttribute('data-dir'), 10));
        input.value = next;
        form.submit();
      });
    });
    // Submit on manual quantity edit (Enter or blur)
    form.querySelectorAll('[data-line-input]').forEach((input) => {
      input.addEventListener('change', () => form.submit());
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  document.querySelectorAll('[data-pm-header]').forEach((header) => {
    const toggle = header.querySelector('[data-pm-header-toggle]');
    const menu = header.querySelector('[data-pm-header-menu]');
    if (!toggle || !menu) return;

    toggle.addEventListener('click', () => {
      const open = header.getAttribute('data-open') === 'true';
      header.setAttribute('data-open', open ? 'false' : 'true');
      toggle.setAttribute('aria-expanded', open ? 'false' : 'true');
    });

    // Close menu when a link is clicked
    menu.querySelectorAll('a').forEach((link) => {
      link.addEventListener('click', () => {
        header.setAttribute('data-open', 'false');
        toggle.setAttribute('aria-expanded', 'false');
      });
    });

    // Close on Escape
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && header.getAttribute('data-open') === 'true') {
        header.setAttribute('data-open', 'false');
        toggle.setAttribute('aria-expanded', 'false');
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["patrick-instagram"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-pm-carousel]').forEach((root) => {
    const track = root.querySelector('[data-pm-carousel-track]');
    const prev = root.querySelector('[data-pm-carousel-prev]');
    const next = root.querySelector('[data-pm-carousel-next]');
    if (!track || !prev || !next) return;

    const scrollByOne = (dir) => {
      const card = track.querySelector(':scope > *');
      if (!card) return;
      const gap = parseFloat(getComputedStyle(track).gap) || 0;
      const dist = (card.getBoundingClientRect().width + gap) * dir;
      track.scrollBy({ left: dist, behavior: 'smooth' });
    };

    prev.addEventListener('click', () => scrollByOne(-1));
    next.addEventListener('click', () => scrollByOne(1));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["patrick-newsletter-popup"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const KEY = 'pm-newsletter-popup-dismissed';
    const popup = document.getElementById('pm-newsletter-popup');
    if (!popup) return;
    if (localStorage.getItem(KEY)) return;

    const delay = parseInt(popup.dataset.delay, 10) * 1000;

    const close = () => {
      popup.hidden = true;
      localStorage.setItem(KEY, Date.now().toString());
    };

    setTimeout(() => {
      popup.hidden = false;
    }, isNaN(delay) ? 15000 : delay);

    popup.querySelectorAll('[data-pm-popup-close]').forEach((el) => {
      el.addEventListener('click', close);
    });

    // After successful form submission, hide popup and set flag
    const form = popup.querySelector('form');
    if (form) {
      form.addEventListener('submit', () => {
        localStorage.setItem(KEY, Date.now().toString());
      });
    }

    // ESC key to close
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && !popup.hidden) close();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["patrick-press"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-pm-carousel]').forEach((root) => {
    const track = root.querySelector('[data-pm-carousel-track]');
    const prev = root.querySelector('[data-pm-carousel-prev]');
    const next = root.querySelector('[data-pm-carousel-next]');
    if (!track || !prev || !next) return;

    const scrollByOne = (dir) => {
      const card = track.querySelector(':scope > *');
      if (!card) return;
      const gap = parseFloat(getComputedStyle(track).gap) || 0;
      const dist = (card.getBoundingClientRect().width + gap) * dir;
      track.scrollBy({ left: dist, behavior: 'smooth' });
    };

    prev.addEventListener('click', () => scrollByOne(-1));
    next.addEventListener('click', () => scrollByOne(1));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  document.querySelectorAll('.pm-product__form').forEach((form) => {
    const qty = form.querySelector('#pm-qty');
    if (!qty) return;
    form.querySelector('[data-qty-minus]')?.addEventListener('click', () => {
      qty.value = Math.max(1, (parseInt(qty.value, 10) || 1) - 1);
    });
    form.querySelector('[data-qty-plus]')?.addEventListener('click', () => {
      qty.value = (parseInt(qty.value, 10) || 1) + 1;
    });

    // Thumbnails swap the main image
    const main = form.closest('.pm-product__wrap')?.querySelector('.pm-product__main-img');
    form.closest('.pm-product__wrap')?.querySelectorAll('.pm-product__thumb').forEach((thumb) => {
      thumb.addEventListener('click', () => {
        if (main) main.src = thumb.src.replace('width=200', 'width=1200');
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
